/*! @azure/msal-browser v5.19.0 2026-08-18 */
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * Get network information for telemetry purposes. This is only supported in Chromium-based browsers.
 * @returns Network connection information, or an empty object if not available.
 */
function getNetworkInfo() {
    if (typeof window === "undefined" || !window.navigator) {
        return {};
    }
    const connection = "connection" in window.navigator
        ? window.navigator.connection
        : undefined;
    return {
        effectiveType: connection?.effectiveType,
        rtt: connection?.rtt,
    };
}
function collectInstanceStats(currentClientId, performanceEvent, logger, correlationId) {
    const frameInstances = 
    // @ts-ignore
    window.msal?.clientIds || [];
    const msalInstanceCount = frameInstances.length;
    const sameClientIdInstanceCount = frameInstances.filter((i) => i === currentClientId).length;
    if (sameClientIdInstanceCount > 1) {
        logger.warning("1e88vg", correlationId);
    }
    performanceEvent.add({
        msalInstanceCount: msalInstanceCount,
        sameClientIdInstanceCount: sameClientIdInstanceCount,
    });
}

export { collectInstanceStats, getNetworkInfo };
//# sourceMappingURL=MsalFrameStatsUtils.mjs.map
